import { render, staticRenderFns } from "./NotePopUp.vue?vue&type=template&id=42804bac&scoped=true&"
import script from "./NotePopUp.vue?vue&type=script&lang=js&"
export * from "./NotePopUp.vue?vue&type=script&lang=js&"
import style0 from "./NotePopUp.vue?vue&type=style&index=0&id=42804bac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42804bac",
  null
  
)

export default component.exports